var $b0gz3$react = require("react");
var $b0gz3$radixuireactusecallbackref = require("@radix-ui/react-use-callback-ref");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useEscapeKeydown", function () {
  return $24c84e9f83c4454f$export$3a72a57244d6e765;
});

/**
 * Listens for when the escape key is down
 */
function $24c84e9f83c4454f$export$3a72a57244d6e765(onEscapeKeyDownProp) {
  var ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  var onEscapeKeyDown = $b0gz3$radixuireactusecallbackref.useCallbackRef(onEscapeKeyDownProp);
  $b0gz3$react.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape') onEscapeKeyDown(event);
    };
    ownerDocument.addEventListener('keydown', handleKeyDown);
    return function () {
      return ownerDocument.removeEventListener('keydown', handleKeyDown);
    };
  }, [onEscapeKeyDown, ownerDocument]);
}